import PhotoGridCardDroppable from './PhotoGridCardDroppable';

export default PhotoGridCardDroppable;
